import React from "react";
import "./ServiceSection.css";
import img1 from "../../../assets/MarysvillePage/Marysville_Ohio_Roofing_Contractor_Near_You.jpg";
import img2 from "../../../assets/MarysvillePage/Columbus_Roofing_Contractor_Near_You.jpg";
import { motion } from "framer-motion";
import Free from "./Free";
import Badge from "./Badge";

const sectionVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: [0.22, 1, 0.36, 1],
      when: "beforeChildren",
      staggerChildren: 0.2,
    },
  },
};

const ServiceSection = () => {
  return (
    <section className="cs-section overflow-hidden py-lg-4 py-3 px-2" style={{backgroundColor: '#f8f9fa'}}>
      <div className="container">
        <div className="row  g-lg-2 g-md-5 g-5">
          {/* Left Side: Content */}
          <motion.div
            className="col-lg-6"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={sectionVariants}
          >
            <div className="base-section-header">
              
              {/* --- Badge Fixed (Top Aligned) --- */}
              <div className="cs-badge d-flex justify-content-lg-start justify-content-center">
              <Badge text="Serving Marysville"></Badge>
              </div>


              <h2
                className="cs-title text-lg-start text-center w-100 font-hauora service-header"
                style={{ color: "#050000" }}
              >
                 Marysville, Ohio, Best Roofing Contractor Near You
              </h2>

              <p
                className="cs-desc font-hauora service-p text-lg-start text-center"
                style={{ lineHeight: "1.7" }}
              >
                Protecting your home or business starts with selecting a trusted residential roofing contractor in Marysville, Ohio, USA. At{" "}
                <a href="https://www.ultimatesroofing.com/" className="text-decoration-none color" target="_blank" rel="noopener noreferrer">
                  Ultimates Roofing
                </a>
                , we bring decades of hands-on experience, expert craftsmanship, and a strong dedication to quality to every project we complete.
                <br /><br />
                From minor roof repairs to full roof replacements, our skilled roofing team delivers strong, long-lasting solutions built to withstand Powell’s unpredictable weather conditions. Whether you’re dealing with storm damage, aging shingles, or planning a brand-new roof installation, we provide fast, affordable, and professional roofing services you can rely on with confidence.
              </p>

            
            </div>
<div className="cs-content">
 <Free />
</div>
           
          </motion.div>

          {/* Right Side: Images */}
          <motion.div
            className="col-lg-6 position-relative ps-lg-5"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className="image-stack-container position-relative">
              <div className="main-image-wrapper rounded-5 shadow-aesthetic overflow-hidden">
                <img
                  src={img2}
                  alt="Commercial Roof"
                  className="img-fluid w-100 h-100 object-fit-cover"
                />
              </div>

              <motion.div
                className="secondary-image-wrapper position-absolute rounded-5 shadow-aesthetic-secondary border border-5 border-white overflow-hidden d-none d-md-block"
                style={{
                  width: "280px",
                  height: "220px",
                  zIndex: 10,
                  bottom: "-5%",
                  right: "-8%",
                }}
              >
                <img
                  src={img1}
                  alt="Roofing Detail"
                  className="img-fluid w-100 h-100 object-fit-cover"
                />
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;